<template>
	<div class="filter-container" :class="{ 'filter-container-fixed': isFixed }"
		:style="{'top':module=='store_product'?'103px !important':'40px !important','margin-top':module=='store_product'?'20px':'5px'}">
		<div style="display: flex;align-items: center;">
			<el-checkbox v-model="useZhSearch" class="terms-checkbox">
				<el-tooltip class="item" placement="bottom">
					<div slot="content">{{$t('zhSerchTip1')}}<br />{{$t('zhSerchTip2')}}</div>
					<span>{{$t('zhSerch')}}</span>
				</el-tooltip>
			</el-checkbox>
		</div>
		<div class="filter-item">
			<el-select v-model="sortBy" :placeholder="$t('defaultSort')" class="filter-select">
				<el-option :label="$t('defaultSort')" value="refresh_time"></el-option>
				<el-option :label="$t('salesSort')" value="buy_count"></el-option>
				<el-option :label="$t('newestSort')" value="upper_time"></el-option>
			</el-select>
		</div>

		<div class="filter-item">
			<el-select v-model="platform" :placeholder="$t('allPlatforms')" class="filter-select" filterable>
				<el-option :label="$t('allPlatforms')" value="all"></el-option>
				<el-option :label="platform.platformName" :value="platform.id" v-for="(platform,index) in platforms"
					:key="index">
				</el-option>
			</el-select>
		</div>

		<div class="filter-item">
			<el-select v-model="priceRange" :placeholder="$t('priceRange')" class="filter-select">
				<el-option :label="$t('allPrices')" value="all"></el-option>
				<el-option label="0 ~ 100" value="0_100"></el-option>
				<el-option label="100 ~ 200" value="100_200"></el-option>
				<el-option label="200 ~ 500" value="200_500"></el-option>
				<el-option label="500 ~ 1000" value="500_1000"></el-option>
				<el-option label="1000+" value="1000_1000000"></el-option>
			</el-select>
		</div>

		<div class="filter-item">
			<el-select v-model="brand" :placeholder="$t('allBrands')" class="filter-select" filterable>
				<el-option :label="$t('allBrands')" value="all"></el-option>
				<el-option :label="item.name" :value="item.id" v-for="(item,index) in brands" :key="index">
				</el-option>
			</el-select>
		</div>

		<!-- <div class="filter-item">
			<el-select v-model="shipping" :placeholder="$t('shippingOption')" class="filter-select">
				<el-option :label="$t('shippingOption')" value="all"></el-option>
				<el-option :label="$t('withShipping')" value="free"></el-option>
				<el-option :label="$t('withoutShipping')" value="paid"></el-option>
			</el-select> -->
	</div>
	</div>
</template>

<script>
	import homeApi from '@/api/home';
	import merchantApi from '@/api/merchant'
	export default {
		name: 'ProductSearchFilter',
		props: {
			isFixed: {
				type: Boolean,
				default: false
			},
			//功能模块，store_product=商家商品,product=商品
			module: {
				type: String,
				default: 'product'
			},
			platformId: {
				type: String,
				defuault: 'all'
			}
		},
		data() {
			return {
				useZhSearch: true, //默认使用中文搜索
				platforms: [],
				brands: [],
				// 查询条件
				sortBy: 'refresh_time',
				platform: 'all',
				priceRange: 'all',
				brand: 'all',
				shipping: 'all'
			}
		},
		watch: {
			platformId(newVal) {
				setTimeout(() => {
					this.platform = newVal;
				}, 200)
			},
			// 监听查询条件变化，触发父组件的事件
			sortBy(newVal) {
				this.$emit('filter-change', this.getFilters());
			},
			platform(newVal) {
				this.$emit('filter-change', this.getFilters());
			},
			priceRange(newVal) {
				this.$emit('filter-change', this.getFilters());
			},
			brand(newVal) {
				this.$emit('filter-change', this.getFilters());
			},
			shipping(newVal) {
				this.$emit('filter-change', this.getFilters());
			}
		},
		methods: {
			init() {
				this.getPlatform();
				this.getBrand();
			},
			//获取代购平台信息
			async getPlatform() {
				const res = await homeApi.getPlatform();
				this.platforms = res.result;
			},
			//获取品牌列表
			async getBrand() {
				const res = await merchantApi.getBrandList();
				this.brands = res;
			},
			// 获取所有查询条件
			getFilters() {
				return {
					sortBy: this.sortBy,
					platform: this.platform,
					priceRange: this.priceRange,
					brand: this.brand,
					shipping: this.shipping
				};
			}
		}
	}
</script>

<style scoped>
	/* Filter container styles */
	.filter-container {
		display: flex;
		gap: 20px;
		justify-content: space-between;
		margin: 20px 0;
	}

	.filter-container.filter-container-fixed {
		position: fixed !important;
		top: 40px !important;
		left: 0 !important;
		right: 0 !important;
		bottom: auto !important;
		z-index: 999 !important;
		background-color: #f2f2f2;
		padding: 15px 20px;
		justify-content: center;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
		margin-top: 20px !important;
	}

	.filter-item {
		display: flex;
		flex-direction: column;
		gap: 5px;
		border: 1px solid #DCDFE6 !important;
		background: #F2F2F2;
		border-radius: 5px;
	}

	.filter-item label {
		font-weight: bold;
		font-size: 14px;
		color: #333;
	}

	.filter-select {
		width: 230px;
	}
</style>